import { render, staticRenderFns } from "./FinesForm.vue?vue&type=template&id=dd244ee8&"
import script from "./FinesForm.vue?vue&type=script&lang=js&"
export * from "./FinesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports